import axios from "axios";
import { PATH } from "../../utils";

// Instancias axios livianas para los modulos de catalogo (Lentes, Colegas).
// No usan redux: cada pagina hace fetch directo y guarda el resultado en
// estado local, siguiendo el mismo patron simple de ProveedoresPage/
// ProveedorDetallePage del proyecto multiproductos, pero sin la capa de
// redux (no hacia falta un store global para estos dos modulos).

export const apiLentes = axios.create({
  baseURL: PATH,
  headers: { "Content-Type": "application/json" },
});

export const apiColegas = axios.create({
  baseURL: PATH,
  headers: { "Content-Type": "application/json" },
});

export const apiAseguradoras = axios.create({
  baseURL: PATH,
  headers: { "Content-Type": "application/json" },
});

export const authHeader = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};
